var aux = require("./__aux");
var i18nLib = require("../i18n");
var Favorites = require("./favorite");

$(document).ready(function () {
	const readyEvent = new Event('ready');

	var changeEventsForMobile = function () {
		var isMobile = aux.isMobile();
		if (isMobile === window.isMobileFilters)
			return; // Prevent false-positives

		if (!isMobile) {
			window.isMobileFilters = false;

			$(".all-filters-button").each(function () {
				var self = $(this);
				// check if button was previously pressed
				if (!self.hasClass('button-clicked')) {
					//If not, then set the default behavior for deskop
					$('.filters-section.tours-page').css('display', 'block');
					self.addClass('arrow-up--icon').removeClass('search--icon');
				}
			});
			// Remove the class 'filter-modal' on desktop
			if ($('.filters-section').hasClass('filter-modal')) {
				$('.filters-section').removeClass('filter-modal');
				$('body').css('overflow', 'auto');
			}

		} else {
			window.isMobileFilters = true;

			$(".all-filters-button").each(function () {
				var self = $(this);
				// check if button was previously pressed
				if (!self.hasClass('button-clicked')) {
					//If not, then set the default behavior for mobile
					$('.filters-section.tours-page').css('display', 'none');
					self.addClass('search--icon').removeClass('arrow-up--icon');
				}
			});
		}
	};
	changeEventsForMobile();
	$(window).resize(aux.debounce(changeEventsForMobile, 100));

	// Match height
	$('.filters-title').matchHeight();

	// Select2's
	$("[data-filter-content-type='no.seeds.as:destination']").select2({
		placeholder: i18nLib.localize("Where do you want to go?")
	});

	$("[data-filter-content-type='no.seeds.as:travel-period']").select2({
		placeholder: i18nLib.localize("Choose season")
	});

	$("[data-filter-content-type='no.seeds.as:theme']").select2({
		placeholder: i18nLib.localize("What do you want to see?")
	});

	$("[data-filter-content-type='no.seeds.as:transportation']").select2({
		placeholder: i18nLib.localize("How do you like to travel?")
	});

	$("[data-filter-content-type='no.seeds.as:travel-type']").select2({
		placeholder: i18nLib.localize("How do you like to travel?")
	});


	function showHideBreadcrumbs () {
		var filterLabel = $(".filters-label label.active");
		if (filterLabel.length > 0) {
			if ($(".arrow-up--icon").is(":visible")) {
				$(".breadcrumbs").show();
			} else {
				$(".breadcrumbs").hide();
			}
		} else {
			$(".breadcrumbs").show();
		}
	}
	showHideBreadcrumbs();

	$(".all-filters-button").on("click", function () {
		$(this).addClass("button-clicked");
		$("#filters").parent().fadeToggle("fast", "linear");
		$("#selected_filters .filters-label").fadeToggle("fast", "linear");
		$(this).toggleClass("arrow-up--icon");
		$(this).toggleClass("search--icon");
		if ($(".arrow-up--icon").is(":visible")) {
			$(".breadcrumbs").show();
		} else {
			if ($(".filters-label label.active").length > 0) {
				$(".breadcrumbs").hide();
			} else {
				$(".breadcrumbs").show();
			}
		}
	});

	// Show filter MODAL on mobile
	$("#openFilters").on("click", function () {
		$("#filters").parent().addClass('filter-modal');
		$("#filters").parent().fadeIn("fast", "linear");
		$('body').css('overflow', 'hidden');
	})

	// Show filter MODAL on mobile (Frontpage)
	$(".filters-section.frontpage .search-tours-btn").on("click", function () {
		$("#filters").parent().addClass('filter-modal');
		$("#filters").parent().fadeIn("fast", "linear");
		$('body').css('overflow', 'hidden');
	})

	// Close filter MODAL on mobile on '.close-btn' click
	$(".filters-section .mobile-header .close-btn").on("click", function () {
		closeFilterModal()
	})

	// Close filter MODAL on mobile on '.filterSubmitButton' click
	$(".filters-section .filterSubmitButton").on("click", function (event) {
		if (!event.isTrigger) {
			closeFilterModal()
		}
	})

	function closeFilterModal () {
		let filterSection = $('#filters').parent()

		if (filterSection.hasClass('frontpage')) {
			$("#filters").parent().removeClass('filter-modal');
			window.scrollTo(0, 0);
			$('body').css('overflow', 'auto');
		} else {
			$("#filters").parent().fadeOut("fast", "linear", function () {
				$(this).removeClass('filter-modal');
				window.scrollTo(0, 0);
				$('body').css('overflow', 'auto');
			});
		}
	}

	function isFrontPage (url) {
		var frontpageUrl = window.location.protocol + '//' + window.location.host;
		return String(url).replace(/\/$/, '') === frontpageUrl;
	}

	function clearAnchors () {
		if (aux.clearUrlAnchor(location.href) !== location.href) {
			if (history.pushState) {
				var locationHref = aux.clearUrlAnchor(location.href);
				window.history.pushState(locationHref, document.title, locationHref);
			} else {
				console.error("OLD BROWSER: history.pushState was not available");
			}
		}
	}

	function scrollTo (selector) {
		window.scrollTo(0, ($(selector).offset() || {}).top || 0);
	}

	$("#filters").on("change", "input", function (params) {
		params = params || {};
		// GET Input Label Content
		var inputId = $(this).attr('id');
		var label = $('label[for=' + inputId + ']').html();

		var style = '';
		if (params.hide) {
			style = ' style="display: none;"';
		}

		if ($(this).prop("checked")) {
			$("#selected_filters .filters-label").append('<label for="' + inputId + '" class="active"' + style + '>' + label + '</label>');
		} else {
			$("#selected_filters label[for='" + inputId + "']").remove();
		}
	});

	$("#startOver, #startOverModal").on("click", function (e) {
		clearAnchors();
		scrollTo("#filters");
		e.preventDefault();

		// get all the inputs into an array.
		var $inputs = $('#filters :input');

		// clear all the filters
		$inputs.each(function () {
			if ($(this).is(":checked")) {
				$(this).prop('checked', false);
			}
			else if ($(this).attr("type") == "text") {
				if ($(this).val())
					$(this).val('');
			}
		});

		// [AS-247]
		$(".filters-label label.active").remove();

		// Revalidate the filters
		submitFn(e, true);

		return false;
	});

	var filtersBox = $('#filters');
	if (filtersBox.is(':visible')) {
		$("#selected_filters .filters-label").fadeToggle("fast", "linear");
	}

	// Default value for advancedSearch
	var advancedSearch = $('#advancedSearch');
	if (advancedSearch && advancedSearch.length > 0) {
		var baseUrl = String(window.location.protocol + '//' + window.location.host).replace(/\/$/, '');
		var toursFolder = $("#toursFolder").val();
		advancedSearch.attr('href', baseUrl + '/' + (toursFolder || '').replace(/^\/|\/$/g, ''));
	}

	function rebuildFromUrl (event) {
		if (!location.search) return event
		var parameterArray = location.search.split(/[?&]/g)
		parameterArray.forEach(function (parameter) {
			if (isNonEmptyString(parameter)) {
				var paramParts = parameter.split(/=/g)
				var paramName = paramParts[0]
				var paramValues = paramParts[1]
				if (isNonEmptyString(paramName) && isNonEmptyString(paramValues)) {
					// decode param values and split them
					paramValues = decodeURIComponent(paramValues).split(/,/g).filter(Boolean)
					paramValues.forEach(function (paramValue) {
						var matchedInputs = $(document.querySelectorAll('[data-filter-type="' + paramName + '"][value="' + paramValue + '"]'))
						matchedInputs.each(function () {
							var matchedInput = $(this)
							var visibleParent = matchedInput.parent(':visible')
							if (visibleParent && visibleParent.length > 0) { // Valid input, since the parent is visible
								// Modify and trigger change
								matchedInput.prop('checked', true)
								matchedInput.trigger('change')
							}
						})
					})
				}
			}
		})
		return event
	}

	function isNonEmptyString (dirtyStr) {
		return typeof dirtyStr === 'string' && dirtyStr.trim()
	}

	// This variable set if the body of response will be updated along with the filters available or not
	let updateFilterAlongWithBody = true

	function submitFn (e, isStartOver) {

		// get all the inputs into an array.
		var $inputs = $('#filters :input');

		// not sure if you wanted this, but I thought I'd add it.
		// get an associative array of just the values.
		var values = {};
		$inputs.each(function () {
			if ($(this).is(":checked")) {
				if (!values[$(this).attr("data-filter-type")]) {
					values[$(this).attr("data-filter-type")] = [];
				}
				values[$(this).attr("data-filter-type")].push($(this).val());
			} else if ($(this).attr("type") == "text") {
				if ($(this).val()) {
					if (!values[$(this).attr("data-filter-type")]) {
						values[$(this).attr("data-filter-type")] = [];
					}
					values[$(this).attr("data-filter-type")].push($(this).val());
				}
			} else if ($(this).attr("type") == "select") {
				if ($(this).val()) {
					var optSelected = $(this).children("option:selected");
					values[optSelected.attr("data-filter-type")] = [$(this).val()];
				}
			}
		});

		var url = aux.clearUrlAnchor(aux.clearUrlQuery(window.location.href));
		var toursFolder = $("#toursFolder").val();
		if (isFrontPage(url)) {
			url = url.replace(/\/$/, '') + '/' + (toursFolder || '').replace(/^\/|\/$/g, '');
		}

		var searchParameters = "{";

		for (var valueKey in values) {
			values[valueKey] = values[valueKey].join(",");
			if (valueKey != "undefined") {
				searchParameters += "\"" + valueKey + "\":\"" + values[valueKey] + "\","
				url = aux.addQSParm(url, valueKey, values[valueKey]);
			}
		}

		if (searchParameters.endsWith(",")) {
			searchParameters = searchParameters.slice(0, searchParameters.length - 1);
		}

		searchParameters += "}";

		$("#experiencesListSection").attr("data-search-parameters", searchParameters);

		var isAutoLoad = Boolean($("#filters").attr("data-is-auto-load"));
		function filterAutoLoadClick () {
			var componentUrl = $("#tourListPartUrl").val();
			var urlQuery = String(url || '').split('?')[1] || '';
			getFilterResults(componentUrl, urlQuery);
		}

		function getFilterResults (componentUrl, urlQuery) {
			var self = $(".tourListPart");
			var toursListUrl = (componentUrl || '').replace(/\/$/g, '/') + (urlQuery ? '?' + urlQuery + '&withFilters=true' : '');

			$.ajax({
				method: "GET",
				cache: false,
				url: toursListUrl,
				success: function (data) {
					var responseHtml = data && $(data).html() || '';
					if (!responseHtml) {
						console.error('EMPTY RESULT!');
					}
					self.html(responseHtml);

					var locationHref = aux.clearUrlAnchor(aux.clearUrlQuery(location.href));
					locationHref += urlQuery ? '?' + urlQuery : '';

					// Url changed
					if (locationHref !== aux.clearUrlAnchor(location.href)) {
						// push state to browser history
						if (history.pushState) {
							window.history.pushState(locationHref, document.title, locationHref);
						} else {
							console.error("OLD BROWSER: history.pushState was not available");
						}
						// call analytics to register pageView
						if (typeof gtag === 'function') {
							var gaTrackingID = $('#gaTrackingID').val();
							if (gaTrackingID) {
								//gtag('config', gaTrackingID, { 'page_path': locationHref });
							}
						}
					}

					bLazy.revalidate();
				},
				beforeSend: function () {
					$('#loading-filter-spinner').removeClass("hidden");
					$('#startOver').addClass("hidden");
				}
			}).then(function (data) {
				Favorites.favoriteTourList()

				var tourListCardsContainer = $("#toursList .theme-categories--cards")
				var experienceListCardsContainer = $("#experiencesList .experiences-list--wrap")
				// Global functions from js/authentic/exchangeCurrencies.js
				var exchangeRateCurrency = window.loadExchangeRateFromSession && window.loadExchangeRateFromSession()
				if (exchangeRateCurrency && tourListCardsContainer[0]) {
					window.switchExchangeRateCurrency(tourListCardsContainer[0], exchangeRateCurrency.from, exchangeRateCurrency.to, exchangeRateCurrency.rate)
				}
				if (exchangeRateCurrency && experienceListCardsContainer[0]) {
					window.switchExchangeRateCurrency(experienceListCardsContainer[0], exchangeRateCurrency.from, exchangeRateCurrency.to, exchangeRateCurrency.rate)
				}

				self.trigger('loadMoreFinished', { response: data });
			}, function () {
				console.error('FAILED: getFilterResults =>\n' + JSON.stringify(arguments, null, 2));
			}).always(function () {
				$('#loading-filter-spinner').addClass("hidden");
				$('#startOver').removeClass("hidden");
				if (urlQuery) {
					$('.articleListPart').addClass("hidden");
				} else {
					$('.articleListPart').removeClass("hidden");
				}
			});

			aux.trySequentially({
				nTimes: 20, callback: function (success, failure) {
					setTimeout(function () {
						bLazy.revalidate();
						failure();
					}, 500);
				}
			});
		}

		function successFn (data) {
			$("#filteredCount").html(data.total);

			if (!isAutoLoad) {
				$(".filterSubmitButton").attr("href", aux.clearUrlAnchor(url));
			} else {
				$('#advancedSearch').attr("href", aux.clearUrlAnchor(url));
			}

			$('.filterSubmitButton').removeClass("hidden");
			$('#startOver').removeClass("hidden");

			$("[data-filter-type]").each(function () {

				if ($(this).attr("type") == "checkbox" && data.enabledFilters.indexOf($(this).attr("data-filter-id")) === -1) {
					$(this).attr("disabled", "disabled");
					$(this).attr('checked', false);
				} else {
					$(this).removeAttr("disabled");
				}
			});

			$('#loading-filter-spinner').addClass("hidden");
		}

		var serviceUrl = $("#filters").attr("data-filter-service-url");

		values.contentType = $("#filters").attr("data-filter-content-type");
		//$.get(serviceUrl, values, successFn, "json");
		$.ajax({
			method: "GET",
			cache: false,
			url: serviceUrl,
			data: values,
			success: function (data) {
				successFn(data);

				if (isAutoLoad) {
					filterAutoLoadClick();
				}

				// Turning this variable to false to avoid infinite loop, since the click event also calls for submitFn
				updateFilterAlongWithBody = false
				$("#experienceFilterSubmit").trigger('click')
			},
			beforeSend: function () {
				$('#loading-filter-spinner').removeClass("hidden");
				$('.filterSubmitButton').addClass("hidden");
				$('#startOver').addClass("hidden");
				filterLoad(true)
			}
		}).fail(function () {
			console.error('FAILED: successFn =>\n' + JSON.stringify(arguments, null, 2));
		}).always(function () {
			$('#loading-filter-spinner').addClass("hidden");
			$('.filterSubmitButton').removeClass("hidden");
			$('#startOver').removeClass("hidden");
			Favorites.favoriteTourList()

			var tourListCardsContainer = $("#toursList .theme-categories--cards")
			// Global functions from js/authentic/exchangeCurrencies.js
			var exchangeRateCurrency = window.loadExchangeRateFromSession && window.loadExchangeRateFromSession()
			if (exchangeRateCurrency && tourListCardsContainer[0]) {
				window.switchExchangeRateCurrency(tourListCardsContainer[0], exchangeRateCurrency.from, exchangeRateCurrency.to, exchangeRateCurrency.rate)
			}

			filterLoad(false)
		});
	}

	$("#advancedSearch").on('click', function (e) {
		clearAnchors();
		if ($(this).attr("href").startsWith('#')) {
			e.preventDefault();
			return false;
		}
	});

	$("#filterSubmit").on('click', function (e) {
		var filterHref = $("#filterSubmit").attr("href");
		if (filterHref.startsWith('#')) {
			e.preventDefault();
			scrollTo(filterHref);
			return false;
		}
		submitFn(e);
		window.location = aux.clearUrlAnchor(filterHref);
	});

	// ##################################################
	$('.otherDestination').on('click', function (e) {
		modalComposition(e.currentTarget.dataset)
		$('#filterNavigateModal').modal('show');
	})

	$("[data-filter-content-type='no.seeds.as:destination']").on('select2:select', function (e) {
		if (e.params.data.element.dataset.modal_link) {
			modalComposition(e.params.data.element.dataset);
			$('#filterNavigateModal').modal('show');
			$("[data-filter-content-type='no.seeds.as:destination']").val(null).trigger('change');
		}
	})
	$("[data-filter-content-type='no.seeds.as:destination']").on('select2:open', function (e) {
		setTimeout(function () {
			$(e.target.options).each(function () {
				var eleName = $(this).val()
				if ($(this).data().arrow) {
					$(`li[id$=-${eleName}]`).html(`${$(this).text()} ${$(this).data().arrow}`)
					$(`li[id$=-${eleName}]`).addClass("otherDestination")
				}
			})
		}, 100)
	});

	$("#experienceFilterSubmit").on('click', function (e) {
		e.preventDefault();

		// This verification and variable avoids infinite loop, since the submitFn also calls this click event
		if (updateFilterAlongWithBody) {
			submitFn(e);
		} else {
			updateFilterAlongWithBody = true
		}

		var componentUrl = $("#experiencesListSection").attr("data-component-url");
		var searchParameters = $("#experiencesListSection").attr("data-search-parameters");
		var dataObj = searchParameters ? JSON.parse(searchParameters) : undefined;

		$.ajax({
			url: componentUrl,
			cache: false,
			data: dataObj,
			success: function (data) {
				$("#experiencesListSection").html($(data).html());

				var pageUrl = $("#experiencesListSection").find("[data-page-url]").attr("data-page-url");

				if (pageUrl) {
					window.history.pushState("", "", pageUrl);
				}

				else {
					window.history.pushState("", "", window.location.pathname);
				}


			},
			cache: false
		}).then(function () {
			Favorites.favoriteTourList()
		});
	});

	// ##################################################

	setTimeout(function () { // Delay some events
		$("#filters input").trigger("change", { hide: true }); // Force active labels on load
		$("#selected_filters label").show(); // Show labels if hidden
		$("#filters").on('change', 'input', aux.debounce(submitFn, 500));//Adding debounce
		$("#filters").on('change', 'select', aux.debounce(submitFn, 500));//Adding debounce
		// Event to run after the full load
		rebuildFromUrl(readyEvent);
	}, 200);

	$("form#filters").on('submit', function (e) {
		event.preventDefault();
		return false;
	})

	function modalComposition (e) {
		e.modal_logo && e.modal_logo.length > 0 ? $('#filterNavigateModalLogo').attr("src", e.modal_logo) : $('#filterNavigateModalLogo').attr("src", $('#filterNavigateModalLogo').data().default_text);
		e.modal_description && e.modal_description.length > 0 ? $('#filterNavigateModalDescription').html(e.modal_description) : $('#filterNavigateModalDescription').html($('#filterNavigateModalDescription').data().default_text);
		e.modal_title && e.modal_title.length > 0 ? $('#filterNavigateModalTitle').text(e.modal_title) : $('#filterNavigateModalTitle').text($('#filterNavigateModalTitle').data().default_text);
		e.modal_cancel && e.modal_cancel.length > 0 ? $('#filterNavigateCancelText').text(e.modal_cancel) : $('#filterNavigateCancelText').text($('#filterNavigateCancelText').data().default_text);
		e.modal_ok && e.modal_ok.length > 0 ? $('#filterNavigateOkText').text(e.modal_ok) : $('#filterNavigateOkText').text($('#filterNavigateOkText').data().default_text);
		e.modal_landscapeimage && e.modal_landscapeimage.length > 0 ? $('#filterNavigateModalLandscapeImage').attr("src", e.modal_landscapeimage) : $('#filterNavigateModalLandscapeImage').attr("src", $('#filterNavigateModalLandscapeImage').data().default_text);
		$('#filterNavigateOkText').attr('href', e.modal_link);
	}

	document.dispatchEvent(readyEvent);

	function filterLoad (start = true) {
		const filtersLoading = document.querySelector('.filters-loading')
		if (!filtersLoading) return

		if (start) {
			filtersLoading.classList.remove('hidden')
		} else {
			filtersLoading.classList.add('hidden')
		}
	}

	// Hiding the loading modal once all the events have been succesfully added to it
	$('.filters-loading').addClass('hidden')
})



// WEBPACK FOOTER //
// ./src/main/resources/assets/js/authentic/filters.js